export default __webpack_public_path__ + "static/media/checkBlack.78669572.svg";